import DropdownButton from '#routes/manage/connections/dropdownButton.jsx';
import { MemoButton } from '#lib/components/button.jsx';
import { addClasses } from '#lib/helpers/class.js';
import { memo } from 'react';

const ImportButton = function (props) {
    const { item, imports, onClick, busy } = props;

    return (
        <div className="flex justify-evenly items-center gap-2 w-full">
            <div className="flex w-full justify-center">
                <DropdownButton params={imports} disabled={imports?.length === 0} />
            </div>
            <div className=" flex w-full justify-center">
                <MemoButton
                    busy={busy}
                    className={addClasses('w-full h-[35px]')}
                    look="primary"
                    onClick={onClick}
                    key={item.id}
                    name={item.number}
                >
                    {_t.orders.import()}
                </MemoButton>
            </div>
        </div>
    );
};

export default memo(ImportButton, (prev, next) => {
    return (
        prev.busy === next.busy && prev.imports.length === next.imports.length && prev.item.number === next.item.number
    );
});
